import React, { useState, useEffect } from 'react';

import { SingleInput, SingleText } from '../../Res/BaseInput';
import {  RespCustomerPositionInfo_WageInfo_WageType3 } from '../../../../item/ItemCustomerPosition';
import { Space } from '../../Res/BaseButton';

export function ItemWageTypeInfo3({ item, action, isEdit = true }) {
  const [wageTypeInfo, setWageTypeInfo] = useState({})
  const [JobCommission, setJobCommission] = useState("")
  const [JobCommissionTerms, setJobCommissionTerms] = useState("")

  const Tilel1 = "每期代招金額"
  const Tilel2 = "期數-（月）"

  useEffect(() => {
    if (item !== undefined && wageTypeInfo !== item) {
      setWageTypeInfo(item)
      setJobCommission(item.JobCommission)
      setJobCommissionTerms(item.JobCommissionTerms)
    }
  }, [item])

  useEffect(() => {
    if (action !== undefined) {
      var mWageTypeInfo = new RespCustomerPositionInfo_WageInfo_WageType3({
        JobCommission,
        JobCommissionTerms
      })
      action(mWageTypeInfo)
    }
  }, [JobCommission, JobCommissionTerms, action])


  return (
    <>
      <div className="hr-line-dashed"></div>
      <div className="row">
        <div className="col-md-12">
          <div className="col-md-6">
            <p>代招 計算條件 - 不足月，按比例計算</p>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-12">
          {
            isEdit ?
              <SingleInput title={Tilel1}
                val={JobCommission}
                action={setJobCommission}
                type={"number"}
              />
              :
              <SingleText title={Tilel1} val={JobCommission} />
          }
          {
            isEdit ?
              <SingleInput title={Tilel2}
                val={JobCommissionTerms}
                action={setJobCommissionTerms}
                type={"number"}
              />
              :
              <SingleText title={Tilel1} val={JobCommissionTerms} />
          }
        </div>
      </div>
      <Space />
      <div className="row">
        <div className="col-md-12">
          <div className="col-md-2">
            <p>特別注意</p>
          </div>
          <div className="col-md-10">
            <strong>外派員工之薪資勞健保都在廠商那裡！單純收期間內的佣金。 思考0.5個月的情況！   </strong>
          </div>
        </div>
      </div>
    </>
  )
}